
import { css } from 'lit';
export default css`
:host{
  --heading-font-family:var(--ff-body);
}

.right-side{
  border-top:4px solid var(--purple-indigo-light);
}

.right-side,
.left-side{
  padding:var(--spacing-8);
}

@media (min-width: 768px){
  .right-side{
    border-top:none;
  }
  .container{
    display:grid;
    grid-template-columns:1fr 1fr;
    border-bottom:4px solid var(--purple-indigo-light);
  }
}

@media (min-width: 992px){
  .right-side{
    background-image:url('data:image/svg+xml;utf8,<svg width="100%" height="auto" viewBox="0 0 595 270" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M437.476 -134L437.476 469L2.99999 469L3 227.399L619 227.399L619 -134L437.476 -134Z" stroke="%23B5A3FF" stroke-width="6" stroke-miterlimit="10"/></svg>');
    background-image:url('data:image/svg+xml;utf8,<svg width="595" height="270" viewBox="0 0 595 270" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M437.476 -134L437.476 469L2.99999 469L3 227.399L619 227.399L619 -134L437.476 -134Z" stroke="%23B5A3FF" stroke-width="6" stroke-miterlimit="10"/></svg>');
    background-repeat:no-repeat;
    background-size:auto;
    background-position:left bottom;
  }
  .right-side,
  .left-side{
    padding:0px;
  }
  .container{
    border-bottom:4px solid transparent;
  }
}
`;